import { default as commandRibbonStore } from '../store/store';
import { isFeatureEnabled } from 'owa-feature-flags';

export function getIsShyRibbonEnabled() {
    return isFeatureEnabled('mon-ribbon-shymode') && commandRibbonStore.shyRibbon;
}
